import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material';

interface OnboardingWelcomeModalProps {
    open: boolean;
    onClose: () => void;
    onYes: () => void;
    onNo: () => void;
}

export default function OnboardingWelcomeModal({ open, onClose, onYes, onNo }: OnboardingWelcomeModalProps) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle>Welcome to Stations!</DialogTitle>
            <DialogContent>
                <Typography variant="body1" sx={{ mt: 1 }}>
                    Would you like to create some example Workflow Routes to help you get started?
                </Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
                    These examples will show you how to structure workflows for common use cases like production orders, real estate
                    projects, and online retail operations.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onNo}>No, Thanks</Button>
                <Button onClick={onYes} variant="contained" color="primary">
                    Yes, Show Examples
                </Button>
            </DialogActions>
        </Dialog>
    );
}
